import React from "react";
import { ContactExpertComponent } from "@components/Block/ContactExpertBlock/ContactExpertComponent";
export function ContactExpert(props) {
    var contactsHeadline = props.contactsHeadline, contactsDescriptionRichText = props.contactsDescriptionRichText, contactsTagLine = props.contactsTagLine, contactsCtaButton = props.contactsCtaButton;
    return (React.createElement(ContactExpertComponent, { title: contactsHeadline, description: contactsDescriptionRichText, tagLine: contactsTagLine, buttons: contactsCtaButton, isFeaturedPage: true }));
}
